import * as actions from 'redux/actions/locales.actions'
import { generateLocationsList } from 'helpers/util'

const initialState = {
  locales: []
}

const localesReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getLocalesSuccess.type:
      return {
        locales: generateLocationsList(payload.locales)
      }
    default:
      return state
  }
}

export default localesReducer
